import { ENERGY_SOURCE_KEY } from "../bisko/energy-source-key";
import { BISKO_METHODOLOGY_LOOKUP_MAP } from "../bisko/methodology-lookup";
const STATIONARY_ENERGY_SOURCE_BY_NAME = BISKO_METHODOLOGY_LOOKUP_MAP.sectors.STATIONARY_ENERGY.energySources;
const isNotGeneralElectricity = (carrierKey) => carrierKey !== ENERGY_SOURCE_KEY.ELECTRICITY;
export const HEAT_CARRIER_KEY_LIST = Object.values(STATIONARY_ENERGY_SOURCE_BY_NAME)
    .map((energySource) => energySource.key)
    .filter(isNotGeneralElectricity);
export const isHeatCarrierKey = (value) => typeof value === "string" &&
    HEAT_CARRIER_KEY_LIST.includes(value);
